import { GroupAnimation } from './basler-components.es726.js';

class GroupAnimationWithThen extends GroupAnimation {
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(() => { });
    }
}

export { GroupAnimationWithThen };
